<template>
  <div class="header">
    {{headTxt}}
  </div>
</template>
<script>
// import Menu from '../../components/common/menu.vue'
// import config from '@/config/index.js'
// const Base64 = require('js-base64').Base64

export default
{
  name: 'Header',
  components: {
    // Menu
  },
  props: {
    headTitle: String
  },
  data() {
    return {
      headTxt:this.headTitle?this.headTitle:"预约查询"
    }
  },
  created() {
    
  },
  mounted() {
    
  },
  filters: {
    
  },
  methods: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .header
  {
    color: #fff;
    padding: 0.2rem;
    font-size: 0.2rem;
    background: $--theme_color;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 2;
  }
</style>